<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  created () {
    const currentLang = this.$cookie.getLang()
    this.$i18n.locale = currentLang || 'en'
  },
}
</script>
<style>
body,
html {
  height: 100%;
  width: 100%;
  padding: 0px;
  margin: 0px;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  width: 100%;
  overflow: auto;
}
.el-col {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
